import type { Bit, GateType } from '../circuit/SignalState';
import { evaluateGate } from '../circuit/LogicEvaluator';

export interface GateDefinition {
  type: GateType;
  zh: string;
  en: string;
  chip: string;
  expression: string;
  explanation: string;
  rows: Array<{ a: Bit; b: Bit; y: Bit }>;
}

const makeRows = (type: GateType): GateDefinition['rows'] =>
  ([0, 1] as Bit[]).flatMap((a) =>
    ([0, 1] as Bit[]).map((b) => ({ a, b, y: evaluateGate(type, a, b) }))
  );

export const GATES: Record<GateType, GateDefinition> = {
  AND: {
    type: 'AND', zh: '与门', en: 'AND Gate', chip: '74HC08N',
    expression: 'Y = A · B', explanation: '仅当两个输入都为 1 时，输出才为 1。',
    rows: makeRows('AND')
  },
  NAND: {
    type: 'NAND', zh: '与非门', en: 'NAND Gate', chip: '74HC00N',
    expression: 'Y = ¬(A · B)', explanation: '与门结果取反，仅当两个输入都为 1 时输出 0。',
    rows: makeRows('NAND')
  },
  OR: {
    type: 'OR', zh: '或门', en: 'OR Gate', chip: '74HC32N',
    expression: 'Y = A + B', explanation: '只要任一输入为 1，输出就是 1。',
    rows: makeRows('OR')
  }
};
